import React from 'react'
import './Content.scss'
import Block from '../Block/Block'

export default ({content}) => {
	return(
		<div className="Content">
			{
				content.map((block, i) => <Block key={i} i={i} blocks={content} id={`Block_${i}`} {...block} />)
			}
		</div>
	)
}